import axiosInstance from '../config/axios';

export const applyCoupon = async (couponData) => {
    return axiosInstance.post(`/coupon/apply`, couponData);
};